// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__25u_T","modal__remainbutton":"deleteModal_modal__remainbutton__2RJ9M","modal__deletebutton":"deleteModal_modal__deletebutton__l-oKV"};